import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
    parsing: {
        xAxisKey: 'name',
        yAxisKey: 'count'
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        plugin1:false,
        plugin2: false,
        datalabels: false,
        legend: {
            display: false
        }     
    }
};


function DashboardDoughnutChart({data, color}) {
    const [graphData, setGraphData] = useState(null);

    useEffect(()=>{
        if(data){
            const newGraphData = {
                labels: data.patientGroupList.map(e=>e.name),
                datasets: [
                    {
                        data: data.patientGroupList.map(e=>e.count),
                        backgroundColor: color,
                        borderWidth: 1,
                    },
                ]
            }
            setGraphData(newGraphData);
        }
    },[data])
    
    return graphData ? (
            <Doughnut data={graphData} options={options} />
    ) : null;
}

export default DashboardDoughnutChart;